import { initSentry } from './instrument';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import './styles/common.css';
import App from './App.tsx';

const renderApp = () => {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <Sentry.ErrorBoundary fallback={<p>应用出现错误，请刷新页面重试。</p>}>
        <App />
      </Sentry.ErrorBoundary>
    </StrictMode>
  );
};

initSentry().finally(() => {
  renderApp();
});
